const query = {
    fields: [],
    sort: [],
    filter: {},
    limit: 100,
    page: 1,
    search: '',
}

export default query